import { render } from "./kyc_info.vue?vue&type=template&id=f73c77c8"
import script from "./kyc_info.vue?vue&type=script&lang=js"
export * from "./kyc_info.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__